const iba = [
  {
    id: 1,
    img: "https://i.ibb.co/d00npPG5/IBA-Dhaka-University-Lean-manufacturing-at-Institute-of-Business-Administration.jpg",
    companyName:
      "IBA- Dhaka University Lean manufacturing at Institute of Business Administration",
  },
  {
    id: 2,
    img: "https://i.ibb.co/hxfp2gqF/IBA-Dhaka-University-Lean-Manufacturing-Institute-of-Business-Administration.jpg",
    companyName:
      "IBA- Dhaka University Lean manufacturing at Institute of Business Administration",
  },
  {
    id: 3,
    img: "https://i.ibb.co/bMWJFcsC/IBA-Dhaka-University-Lean-Manufacturing-for-the-students-of-SEIP-GB-at-Institute-of-Business-Adminis.jpg",
    companyName:
      "IBA- Dhaka University Lean manufacturing for the students of SEIP- GB at Institute of Business Administration",
  },
  {
    id: 4,
    img: "https://i.ibb.co/svpTcZcZ/IBA-Dhaka-University-Training-Lean-Six-Sigma-and-Kaizen-1st-Session.jpg",
    companyName:
      "IBA- Dhaka University Training Lean Six Sigma and Kaizen 1st Session",
  },
  {
    id: 5,
    img: "https://i.ibb.co/ZRkrKzQy/IBA-Dhaka-University-Training-Lean-Six-Sigma-and-Kaizen-2nd-Session.jpg",
    companyName:
      "IBA- Dhaka University Training Lean Six Sigma and Kaizen 2nd Session",
  },
  {
    id: 6,
    img: "https://i.ibb.co/LHRKw3n/IBA-Dhaka-University-Training-Lean-Six-Sigma-and-Kaizen-3rd-Session.jpg",
    companyName:
      "IBA- Dhaka University Training Lean Six Sigma and Kaizen 3rd Session",
  },
  {
    id: 7,
    img: "https://i.ibb.co/1GGZLxnJ/IBA-Dhaka-University-Training-Lean-Six-Sigma-and-Kaizen.jpg",
    companyName: "IBA- Dhaka University Training Lean Six Sigma and Kaizen",
  },
  {
    id: 8,
    img: "https://i.ibb.co/DDKg4cWd/IBA-Dhaka-University-Training-Lean-Six-Sigma-and-Kaizen-2.jpg",
    companyName: "IBA- Dhaka University Training Lean Six Sigma and Kaizen",
  },
  {
    id: 9,
    img: "https://i.ibb.co/LBDmmHY/IBA-Dhaka-University-Training-Lean-Six-Sigma-and-Kaizen-3.jpg",
    companyName: "IBA- Dhaka University Training Lean Six Sigma and Kaizen",
  },

  // {
  //   id: 12,
  //   img: "https://i.ibb.co/ycfLmWb0/Be-the-Best-Version-of-Yourself-Make-Rest-of-Your-Life-the-Best-of-Your-Life-at-East-West-University.jpg",
  //   companyName:
  //     "Be the Best Version of Yourself “ & “Make Rest of Your Life the Best of Your Life” at East West University",
  // },
];

export default iba;
